/*  /frontend/src/pages/ResetPassword.js
    Greatly Social – Reset-Password screen
    FULL FILE — NOTHING OMITTED
    ------------------------------------------------------------------ */

import '../custom.css'

import React, { useState } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { Container, Row, Col, Image, Alert, Spinner, Button } from 'react-bootstrap'
import { CheckCircleFill } from 'react-bootstrap-icons'

/* ─── assets ─────────────────────────────────────────────────────── */
const logoUrl = '/assets/logo/greatly-social-full.png'

export default function ResetPassword () {
  /* ------------- route param ------------- */
  const { token } = useParams()

  /* ------------- state ------------- */
  const [password, setPwd]    = useState('')
  const [confirm,  setConfirm] = useState('')
  const [loading,  setLoading] = useState(false)
  const [msg,      setMsg]     = useState({ text: '', variant: 'success' })

  const navigate = useNavigate()

  /* ------------- submit ------------- */
  const handleSubmit = async e => {
    e.preventDefault()

    if (password !== confirm) {
      return setMsg({ text: 'Passwords do not match', variant: 'danger' })
    }

    setMsg({ text: '', variant: 'success' })
    setLoading(true)

    try {
      const url = `${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`
      const res = await fetch(url, {
        method : 'POST',
        headers: { 'Content-Type': 'application/json' },
        body   : JSON.stringify({ token, password }),
      })
      const data = await res.json()

      if (res.ok) {
        setMsg({ text: data.message, variant: 'success' })
        setTimeout(() => navigate('/login'), 1500)
      } else {
        setMsg({ text: data.message, variant: 'danger' })
      }
    } catch (err) {
      console.error('[RESET-PW] network error', err)
      setMsg({ text: 'Network error – please try again.', variant: 'danger' })
    } finally {
      setLoading(false)
    }
  }

  /* ------------- ui ------------- */
  return (
    <section className='bg-light min-vh-100 d-flex align-items-center'>
      <Container>
        <Row className='justify-content-center'>
          <Col md={6} className='bg-white p-5 shadow-lg rounded-4'>
            <Image src={logoUrl} alt='Greatly Social logo' width={200} fluid className='mb-4' />

            <h2 className='fw-bold mb-4'>Choose a new password</h2>

            {msg.text && (
              <Alert variant={msg.variant} className='d-flex align-items-center'>
                {msg.variant === 'success'
                  ? <CheckCircleFill className='me-2' />
                  : <span className='me-2'>❗</span>}
                {msg.text}
              </Alert>
            )}

            <form onSubmit={handleSubmit}>
              <div className='mb-3'>
                <label htmlFor='password' className='form-label'>New password</label>
                <input
                  id='password'
                  type='password'
                  className='form-control'
                  value={password}
                  onChange={e => setPwd(e.target.value)}
                  required
                />
              </div>

              <div className='mb-4'>
                <label htmlFor='confirm' className='form-label'>Confirm password</label>
                <input
                  id='confirm'
                  type='password'
                  className='form-control'
                  value={confirm}
                  onChange={e => setConfirm(e.target.value)}
                  required
                />
              </div>

              <Button
                variant='primary'
                type='submit'
                disabled={loading}
                className='w-100'
                size='lg'
              >
                {loading ? <Spinner animation='border' size='sm' /> : 'Reset password'}
              </Button>
            </form>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
